import {LastLocation} from "../books/last-locations";
import {AsyncNotice} from "../notices/notice";

function addPinEventHandlers() {
  // add event listeners to pins after updating table rows
  const pins = document.querySelectorAll('div.pin a');
  pins.forEach((pin) => {
    pin.addEventListener('click', async (e) => {
      await pinClickListener(e, pin, 'last-locations');
    })
  })
}

/**
 * Click event Listener for a given pin. Render a spinner, pin the title and update the table rows.
 *
 * @param e
 * @param pin
 * @param paginatorName
 * @returns {Promise<void>}
 */
async function pinClickListener(e, pin, paginatorName) {
  e.preventDefault();
  try {
    // show spinner
    let spinner = document.createElement('span');
    spinner.classList.add('loader');

    pin.parentElement.insertAdjacentElement('beforeend', spinner);

    // handle click on pin
    let isPinned = (pin.classList.contains('is-pinned'));

    let table = document.querySelector(`#${paginatorName}-collection`);
    let options = JSON.parse(table.dataset.options);
    let currentPage = options.collection.currentPage;
    let url = table.dataset.updateUrl;
    let itemsPerPageElem = document.querySelector(`#${paginatorName}-items-per-page`);
    let itemsPerPage = itemsPerPageElem.value;

    // async call to update 'Pinned' column on DB record
    let l = new LastLocation({url: url});
    let id = pin.parentElement.dataset.id;
    let result = await l.save({id, currentPage, itemsPerPage, pinned: !isPinned, options});
    if(result.success) {
      updateTableContent(table, result); // this currently also remove the spinner since the content is replacec
    } else {
      // console.log(result['msg']);
      let message = result['msg'] ?? 'There was an error updating this record.';
      let notice = new AsyncNotice(message, 'error');

      await notice.create({}, true);
      notice.remove();
    }

    await spinner.remove();

  } catch(error) {
    let msg = 'There was an error updating this record.';
    console.log(`msg: ${error.message}.`);

    let notice = new AsyncNotice(msg, 'error');
    await notice.create({}, true);
    notice.remove();
  }
}

/**
 * update the 'Continue Reading' table with updated rows.
 *
 * @param table
 * @param result
 */
function updateTableContent(table, result) {
  // update the last locations collection
  table.tBodies[0].innerHTML = result.rows;

  addPinEventHandlers();
}

export {addPinEventHandlers};
